import { gql } from '@apollo/client'

export const GET_MY_CAREER_ENTRIES = gql`
  query GetMyCareerEntries {
    myCareerEntries {
      id
      role
      startDate
      endDate
      details
      careerOrganization {
        id
        name
      }
    }
  }
`

export const SEARCH_CAREER_ORGANIZATIONS = gql`
  query SearchCareerOrganizations($term: String!, $limit: Int) {
    careerOrganizations(term: $term, limit: $limit) {
      id
      name
    }
  }
`
